export const formatUsername = (username: string) => username.trim().toLowerCase();